<accordion>
  @for (item of guaranteeNotes; track item; let i = $index) {
    <accordion-group class="list-accounts" #accGroup
      [isOpen]="accGroup?.isOpen || isSelectedGuaranteeNote(item)">
      <span accordion-heading>
        <div class="account-items font-13 d-flex align-items-center {{ item.subGuaranteeNotes.length == 0?'last-level':''}}">
          @if (item.subGuaranteeNotes.length !== 0) {
            <button class="btn" type="button" id="{{item.id}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"
            [ngClass]="{'pl-5': item.subGuaranteeNotes.length === 0}">
            {{item.name}}
          </span>
          <input
            type="checkbox"
            (click)="$event.stopPropagation()"
            (change)="changeNoteStatus(item, $event)"
            class="account-checkbox"
            [disabled]="item.mandatory"
            [checked]="isSelectedGuaranteeNote(item)">
          </div>
        </span>
        @if (item.subGuaranteeNotes.length !== 0) {
          <div>
            <app-guarantee-note-node
              [guaranteeNotes]="item.subGuaranteeNotes"
              [selectedGuaranteeNotes]="selectedGuaranteeNotes"
              (onAddGuaranteeNote)="addGuaranteeNote($event)"
              (onDeleteGuaranteeNote)="deleteGuaranteeNote($event)">
            </app-guarantee-note-node>
          </div>
        }
      </accordion-group>
    }
  </accordion>